import { Component } from '@angular/core';

@Component({
  selector: 'app-add-edit-pages-skeleton',
  templateUrl: './add-edit-pages-skeleton.component.html',
  styleUrls: ['./add-edit-pages-skeleton.component.scss'],
})
export class AddEditPagesSkeletonComponent {}
